import { render, staticRenderFns } from "./HelpSavedItem.vue?vue&type=template&id=e5e89e0c&"
import script from "./HelpSavedItem.vue?vue&type=script&lang=js&"
export * from "./HelpSavedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports